import { pagesDevicesContractAndCostEn } from '../devices/contract-and-cost/default';

export const pagesPayrollEn = {
  alerts: {
    actions: {
      review: 'Review',
      toastDescription: 'This action is not available in the demo.',
      toastTitle: 'Action',
    },
    categories: {
      all: 'All',
      calculation: 'Calculation',
      compliance: 'Compliance',
      deadline: 'Deadline',
      payment: 'Payment',
    },
    toolbar: {
      employeeChip: 'Employee',
      exportToastDescription: 'Export is not available in the demo.',
      exportToastTitle: 'Export',
      filterChip: 'Filter',
      fullscreenAria: 'Fullscreen',
      fullscreenToastDescription: 'Fullscreen is not available in the demo.',
      fullscreenToastTitle: 'Fullscreen',
      payGroupChip: 'Pay structure',
      periodChip: 'Period',
      searchPlaceholder: 'Search…',
      shareAria: 'Share',
      shareToastDescription: 'Share is not available in the demo.',
      shareToastTitle: 'Share',
    },
    types: {
      calc_failed: 'Calculation failed',
      closing_deadline_exceeded: 'Closing deadline exceeded',
      deduction_exceeds_gross: 'Deductions exceed gross',
      fb_data_mismatch: 'FB data mismatch',
      minimum_wage_violation: 'Minimum wage violation',
      missing_bank_account: 'Missing bank account',
      negative_net_pay: 'Negative net pay',
      overtime_rate_mismatch: 'Overtime rate mismatch',
      payment_date_overdue: 'Payment date overdue',
      resident_tax_update_due: 'Resident tax update due',
      withholding_tax_anomaly: 'Withholding tax anomaly',
      year_end_adjustment_pending: 'Year-end adjustment pending',
    },
  },
  contractAndCost: {
    chart: {
      actual: 'Actual',
      helpTooltip: 'Chart description (mock)',
      monthLabel: 'M{{n}}',
      planned: 'Scheduled',
      title: 'Payment trend',
      variance: 'Schedule variance',
    },
    costPlaceholder: {
      subtitle: 'Cost analytics for payroll will appear here.',
      title: 'Cost overview coming soon',
    },
    dealPlaceholder: {
      subtitle: 'Contract and deal workflows will appear here.',
      title: 'Deal management coming soon',
    },
    expandFullscreen: 'Expand to fullscreen',
    filterComingSoon: 'This filter is not available yet.',
    monthlyNotAvailable: {
      subtitle: 'Use trend view for the department breakdown.',
      title: 'Monthly view is not available',
    },
    paymentOverview: pagesDevicesContractAndCostEn.paymentOverview,
    placeholder: {
      subtitle: 'Switch to “Payment” to view the dashboard.',
      title: 'This section is not available yet',
    },
    searchPlaceholder: 'Search…',
    stats: {
      actualPaymentThisFy: 'Actual payment (this fiscal year)',
      externalHint: 'Open related view (coming soon)',
      helpTooltip: 'Metric description (mock)',
      nextPaymentFoot: '{{date}} · {{days}} days to go',
      nextScheduledPayment: 'Next scheduled payment',
      scheduledPaymentThisFy: 'Scheduled payment (this fiscal year)',
      scheduledPaymentThisMonth: 'Scheduled payment (this month)',
      thisMonthFoot: '—',
      vsPlanShort: 'vs. scheduled',
      yoyLabel: 'YoY',
    },
    subNav: {
      cost: 'Cost',
      employment: 'Employment contract',
      fiscalYear: 'Fiscal year',
      fiscalYearPlaceholder: 'Select fiscal year',
      fy2024: 'FY2024 –',
      payment: 'Payment',
    },
    table: {
      attention: {
        overtime_exceeded: 'Overtime exceeded',
      },
      dept: {
        corporate: 'Corporate',
        customerSuccess: 'Customer Success',
        development: 'Development',
        manufacturing: 'Manufacturing',
        sales: 'Sales',
      },
      title: 'By department',
      totalActual: 'Actual',
      totalFte: 'FTE',
      totalHeadcount: 'Headcount',
      totalOvertime: 'Overtime pay',
      totalRow: 'Total',
    },
    toolbar: {
      attentionFlag: 'Attention flag',
      columnSettings: 'Column settings',
      department: 'Department',
      marketMenu: 'Open menu',
      viewSingleMonth: 'Single month',
      viewTrend: 'Trend',
    },
  },
  detail: {
    backToList: 'Back to pay slips',
    files: {
      folders: 'Folders',
      noFiles: 'No files',
      noFolders: 'No folders',
      title: 'Files',
    },
    records: {
      categories: {
        deduction: 'Deductions',
        earning: 'Earnings',
        net_pay: 'Net Pay',
        social_insurance: 'Social Insurance',
        tax: 'Tax',
      },
      columns: {
        amount: 'Amount',
        category: 'Category',
        department: 'Department',
        description: 'Description',
        employee: 'Employee',
        itemCode: 'Code',
        itemName: 'Item',
      },
      title: 'Pay Slip Records',
    },
    tabs: {
      files: 'Files',
      overview: 'Overview',
      records: 'Records',
    },
  },
  employeeDetail: {
    attendance: {
      fields: {
        absenceDays: 'Absence days',
        attendanceDays: 'Days worked',
        holidayWorkDays: 'Holiday work days',
        holidayWorkHours: 'Holiday work hours',
        lateEarlyHours: 'Late / early hours',
        nightOvertimeHours: 'Night overtime hours',
        overtimeHours: 'Overtime hours',
        paidLeaveRemainingDays: 'Paid leave remaining',
        paidLeaveUsedDays: 'Paid leave used',
        scheduledWorkDays: 'Scheduled work days',
        workHours: 'Work hours',
      },
      sectionTitle: 'Attendance',
      units: {
        day: 'days',
        hour: 'hours',
      },
    },
    breadcrumb: {
      paySlips: 'Pay slips',
      payroll: 'Payroll',
      /** Hub label in member detail breadcrumb (Figma: payroll calculation area) */
      payrollCalculation: 'Payroll',
    },
    documentTitle: '{{name}} — Pay slip',
    documentTitleLoading: 'Pay slip',
    empty: 'No pay slips for this employee.',
    emptyPeriod: 'No pay slip data for this month.',
    files: {
      actions: {
        back: 'Back',
        delete: 'Delete',
        deleteToastDescription: 'Delete is not available in the demo.',
        deleteToastTitle: 'Delete',
        download: 'Download',
        downloadToastDescription: 'Download is not available in the demo.',
        downloadToastTitle: 'Download',
        openFolder: 'Open {{folderName}}',
        previewToastDescription: 'Preview is not available in the demo.',
        previewToastTitle: 'Preview',
        rename: 'Rename',
        renameToastDescription: 'Rename is not available in the demo.',
        renameToastTitle: 'Rename',
      },
      columns: {
        fileCount: 'Files',
        fileName: 'File name',
        folder: 'Folder',
        updatedAt: 'Updated',
        uploadedBy: 'Uploaded by',
      },
      folders: {
        bonus: 'Bonus statements',
        payslip: 'Pay slips',
        yearEndAdjustment: 'Year-end adjustment',
      },
      title: 'Files',
    },
    history: {
      addComparison: 'Add comparison',
      categories: {
        attendance: 'Attendance & basis',
        earnings: 'Earnings',
        result: 'Results',
        social_insurance: 'Social insurance',
        tax: 'Tax',
      },
      collapsePayItemLines: 'Collapse breakdown for {{label}}',
      columnLabels: {
        variable: 'Variable / category',
      },
      currentBadge: 'Current',
      emptyNoSnapshots: 'No calculation history for this month.',
      expandPayItemLines: 'Expand breakdown for {{label}}',
      searchAriaLabel: 'Search calculation history',
      searchPlaceholder: 'Find history…',
      showChangesOnly: 'Show only changes',
    },
    pageTitlePrefix: 'Pay slip:',
    sections: {
      deductions: 'Deductions',
      earnings: 'Earnings',
    },
    summary: {
      deductionsTotal: 'Total deductions',
      grossTotal: 'Total gross pay',
      netPay: 'Net payment',
    },
    tabPlaceholderSubtitle: 'This tab is not available in the demo.',
    tabPlaceholderTitle: 'Coming soon',
    tabs: {
      alerts: 'Alerts',
      files: 'Files',
      history: 'History',
      overview: 'Overview',
      payslip: 'Pay slip',
      settings: 'Settings',
    },
    tabsAriaLabel: 'Employee pay slip sections',
    viewPdf: 'View PDF',
  },
  overview: {
    cards: {
      laborCostRatioByDepartment: 'Monthly labor cost ratio (by department)',
      laborCostRatioByOffice: 'Monthly labor cost ratio (by office)',
      overtimeCostRatioByDepartment:
        'Monthly overtime cost ratio (by department)',
      overtimeCostRatioByOffice: 'Monthly overtime cost ratio (by office)',
      overtimePayByDepartment: 'Monthly overtime pay (by department)',
      overtimePayByOffice: 'Monthly overtime pay (by office)',
      totalPayrollByDepartment: 'Monthly payroll (by department)',
      totalPayrollByOffice: 'Monthly payroll (by office)',
    },
    departments: {
      accounting: 'Accounting',
      development: 'Development',
      general_affairs: 'General Affairs',
      hr: 'HR',
      sales: 'Sales',
    },
    loading: 'Loading…',
    organizations: {
      allOrganizations: 'All organizations',
      fukuoka: 'Fukuoka',
      osaka: 'Osaka',
      sapporo: 'Sapporo',
      searchPlaceholder: 'Search…',
      sendai: 'Sendai',
      tokyo_hq: 'Tokyo HQ',
    },
    periods: {
      months: {
        feb: 'Feb 2026',
        jan: 'Jan 2026',
        mar: 'Mar 2026',
      },
      searchPlaceholder: 'Search…',
    },
    trend: {
      forecastEnd: 'Forecast end of FY',
      markerMonth: 'M{{month}}',
      markerPrimary: '{{manYen}} 万',
      monthlyAverage: 'Monthly average',
      monthlyCap: 'Monthly cap {{manYen}} 万',
      title: 'Monthly payroll trend',
    },
    units: {
      manYen: '万円',
      percent: '%',
    },
  },
  pageTitle: 'Payroll',
  paySlips: {
    expandFullscreen: 'Expand to fullscreen',
    filter: 'Filter',
    filterComingSoon: 'This filter is not available yet.',
    filters: {
      employee: 'Employee',
      employmentType: 'Employment type',
      operationActivity: 'Operation activity',
      organization: 'Organization',
      workLocation: 'Work location',
    },
    nextMonth: 'Next month',
    prevMonth: 'Prev month',
    searchPlaceholder: 'Search by name...',
  },
  settings: {
    title: 'Settings',
  },
  tabs: {
    alerts: 'Alerts',
    contractAndCost: 'Contract & Cost',
    overview: 'Overview',
    paySlips: 'Pay Slips',
    ruleAndPolicy: 'Rule & Policy',
    settings: 'Settings',
  },
};
